// This file is automatically generated. Do not edit manually.

import { t } from "i18next";

export const CustomerOrderStateValues = [
	"RECEIVED",
	"INITIAL",
	"RELEASED",
	"RESERVED",
	"PICKED",
	"PARTIALLY_DELIVERED",
	"DELIVERED",
	"INVOICED",
	"CANCELLED",
] as const;

export type CustomerOrderState = (typeof CustomerOrderStateValues)[number];

export const getCustomerOrderStateLabels = () => ({
	RECEIVED: t("received"),
	INITIAL: t("initial"),
	RELEASED: t("released"),
	RESERVED: t("reserved"),
	PICKED: t("picked"),
	PARTIALLY_DELIVERED: t("partially_delivered"),
	DELIVERED: t("delivered"),
	INVOICED: t("invoiced"),
	CANCELLED: t("cancelled"),
});

export const getCustomerOrderStateLabel = (value: CustomerOrderState): string => {
	return getCustomerOrderStateLabels()[value];
};
